"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridCheckboxCell = void 0;
const react_1 = __importStar(require("react"));
const controls_1 = require("../../../../../controls");
const GridCoreSkeleton_1 = require("../../../../components/GridCoreSkeleton/GridCoreSkeleton");
const GridCheckboxCell_styles_1 = require("./GridCheckboxCell.styles");
exports.GridCheckboxCell = react_1.default.memo(function GridCheckboxCell({ disabled, onClick, checked, loading }) {
    const handleOnClick = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (disabled) {
            return;
        }
        onClick(e);
    }, [disabled, onClick]);
    return (react_1.default.createElement(GridCheckboxCell_styles_1.StyledGridCheckboxCell, { "data-selector-id": "grid-core-checkbox-cell", className: "vm-GridCheckboxCell" }, loading ? (react_1.default.createElement(GridCoreSkeleton_1.GridCoreSkeleton, { width: '20px' })) : (react_1.default.createElement(controls_1.Checkbox, { onClick: handleOnClick, checked: checked, disabled: disabled, buildIn: true }))));
});
//# sourceMappingURL=GridCheckboxCell.js.map